import React from "react";
import { cn } from "@/lib/utils";

interface PlayingIndicatorProps {
  isPlaying?: boolean;
  isLoading?: boolean;
  className?: string;
}

// Simple equalizer-style playing indicator using Tailwind animations
export const PlayingIndicator: React.FC<PlayingIndicatorProps> = ({ isPlaying = true, isLoading = false, className }) => {
  const barBase = "w-1.5 rounded-sm bg-primary transition-all duration-300";
  const heights = "h-3 sm:h-4 md:h-5";
  
  // Loading animation: pulse effect
  if (isLoading) {
    return (
      <div className={cn("flex items-center gap-1 h-6", className)} aria-hidden>
        <div className={cn(barBase, "h-2 animate-pulse")} style={{ animationDelay: "0ms" }} />
        <div className={cn(barBase, "h-3 animate-pulse")} style={{ animationDelay: "150ms" }} />
        <div className={cn(barBase, "h-4 animate-pulse")} style={{ animationDelay: "300ms" }} />
        <div className={cn(barBase, "h-3 animate-pulse")} style={{ animationDelay: "450ms" }} />
        <div className={cn(barBase, "h-2 animate-pulse")} style={{ animationDelay: "600ms" }} />
      </div>
    );
  }
  
  // Playing/paused animation
  const anim = isPlaying ? "animate-bounce" : "opacity-50";

  return (
    <div className={cn("flex items-end gap-1 h-6", className)} aria-hidden>
      <div className={cn(barBase, heights, anim)} style={{ animationDelay: "0ms" }} />
      <div className={cn(barBase, heights, anim)} style={{ animationDelay: "100ms" }} />
      <div className={cn(barBase, heights, anim)} style={{ animationDelay: "200ms" }} />
      <div className={cn(barBase, heights, anim)} style={{ animationDelay: "300ms" }} />
      <div className={cn(barBase, heights, anim)} style={{ animationDelay: "400ms" }} />
    </div>
  );
};

export default PlayingIndicator;
